export const generateColors = (numColors: number): string[] => {
  const startHue = 0.52 * 360;
  const hueStep = 360 / numColors;
  return Array.from(
    { length: numColors },
    (_, i) => `hsl(${(startHue + i * hueStep) % 360}, 78%, 50%)`
  );
};
